import { SxProps, Theme } from "@mui/material";
import UseAutocomplete from "../../core/components/autocomplete/UseAutocomplete";
import { Dungeons, Grottos, Interiors, MixPoolPlace, OverworldEntrances } from "./MixPoolNotes";

interface MixPoolPlaceAutocompleteProps {
    sx?: SxProps<Theme> | undefined
}

const MixPoolPlaceAutocomplete = (props: MixPoolPlaceAutocompleteProps) => {

    let pool: Array<MixPoolPlace> = [{ name: "x", autocompleteName: "X", type: "interior", isImportant: false, zone: "ALL" }, ...Interiors.filter(x => x.autocompleteName !== "X"), ...Grottos.filter(x => x.autocompleteName !== "X"), ...Dungeons, ...OverworldEntrances]

    let uniquePool: Array<MixPoolPlace> = []

    pool.forEach(x => {
        if (!uniquePool.some(p => p.autocompleteName === x.autocompleteName)) {
            uniquePool.push(x)
        }
    })

    let autocomplete = UseAutocomplete({ options: uniquePool, sx: {...props.sx, height: 28, width: 140} });

    return autocomplete
}

export default MixPoolPlaceAutocomplete